import React from "react";
import Card2 from "../Images/Headers/team.jpg";
import "./OurStaff.css";
import { Breadcrumb } from "react-bootstrap";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import { IconButton } from "@mui/material";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

import Card1 from "../Images/Profiles/Isaac Ahimbisiibwe_Profile Pic.jpg";
import Card4 from "../Images/Profiles/Aran.jpg";
import Card5 from "../Images/Profiles/Davis.jpg";
import Card6 from "../Images/Profiles/Eunice.jpg";
import Card7 from "../Images/Profiles/Hasifa.jpg";
import Card8 from "../Images/Profiles/Jonah.jpg";
import Card9 from "../Images/Profiles/Livingstone.jpg";
import Card10 from "../Images/Profiles/Patricia.jpg";
import Card11 from "../Images/Profiles/Patrick (2).jpg";
import Card12 from "../Images/Profiles/Carol.jpg";
import Card13 from "../Images/Profiles/Rashid.jpg";
import Card14 from "../Images/Profiles/Bernard.jpg";

/* ─── Centralised staff data ─────────────────────────────── */
const STAFF = [
  {
    id: "isaac-ahimbisiibwe",
    photo: Card1,
    name: "Mr. Isaac Ahimbisiibwe",
    role: "Research Associate",
    bio: "Isaac earned a Master's Degree in Gender Studies from Makerere University and has built a distinguished academic and professional career…",
    linkedin: "https://www.linkedin.com/in/isaac-ahimbisiibwe-883919162/",
    twitter: "https://twitter.com/IsaacAhimbisii1",
    facebook:
      "https://m.facebook.com/people/Isaac-Ahimbisiibwe/100010181948317/",
    whatsapp: "https://wa.me/256752814376",
    email: "isaac.ahimbisiibwe@circodu.org.ug",
  },
  {
    id: "patrick-waweyo",
    photo: Card11,
    name: "Mr. Patrick Waweyo",
    role: "IT Officer / Data Manager",
    bio: "Patrick is a computer engineer whose career spans education, technology, and environmental advocacy, holding a Bachelor's degree in Computer Engineering…",
    linkedin: "https://www.linkedin.com/in/patrickwaweyo/",
    twitter: "https://twitter.com/NtabuPaddy",
    facebook: "https://www.facebook.com/Circodu/",
    whatsapp: "https://wa.me/256705807536",
    email: "patrick.waweyo@circodu.org.ug",
  },
  {
    id: "carol-gabeya",
    photo: Card12,
    name: "Ms. Caroline Gabeya",
    role: "Office Administrator",
    bio: "Ms. Gabeya holds a Bachelor's degree in Adult and Community Education from Makerere University and a certificate in community development…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1/",
    facebook: "https://www.facebook.com/Gabbi.carolyne?mibextid=ZbWKwL/",
    whatsapp: "https://wa.me/256703436196",
    email: "carol.gabeya@circodu.org.ug",
  },
  {
    id: "patricia-nyansheegu",
    photo: Card10,
    name: "Ms. Patricia Nyansheegu",
    role: "Laboratory Quality Manager",
    bio: "Patricia holds a Bachelor's Degree in Conservation Forestry and Products Technology from Makerere University and is an accomplished quality professional…",
    linkedin: "https://www.linkedin.com/in/patricia-nyansheegu-62473b286/",
    twitter: "https://twitter.com/Patricia0781161",
    facebook: "https://www.facebook.com/patricia.nyansheegu",
    whatsapp: "https://wa.me/256781165201",
    email: "patricia.nyansheegu@circodu.org.ug",
  },
  {
    id: "rashid-seggujja",
    photo: Card13,
    name: "Mr. Rashid Seggujja",
    role: "Laboratory Technical Manager",
    bio: "Rashid holds a Bachelor's Degree in Industrial and Organizational Psychology from Makerere University, with a rich journey in laboratory management…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/rasheed.seggujja",
    whatsapp: "https://wa.me/256701447940",
    email: "rashid.seggujja@circodu.org.ug",
  },
  {
    id: "davis-kintu",
    photo: Card5,
    name: "Mr. Davis Kintu",
    role: "Senior Laboratory Technician",
    bio: "Davis graduated from Makerere University with a Bachelor's degree in Environmental Management, complemented by a series of professional certifications…",
    linkedin: "https://ug.linkedin.com/in/kintu-davis-1744286b/",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/muwanguzi.davis.12/",
    whatsapp: "https://wa.me/256700127623",
    email: "davis.kintu@circodu.org.ug",
  },
  {
    id: "livingstone-kilwa",
    photo: Card9,
    name: "Mr. Livingstone Kilwa",
    role: "Laboratory Technician",
    bio: "Kilwa holds a Bachelor's Degree in Development Studies from Makerere University, fortified by an array of valuable professional certifications…",
    linkedin: "https://www.linkedin.com/in/kilwa-livingstone-659436180/",
    twitter: "https://twitter.com/Stone8924",
    facebook: "https://www.facebook.com/kilwa.livingstone/",
    whatsapp: "https://wa.me/256706901771",
    email: "kilwa.livingstone@circodu.org.ug",
  },
  {
    id: "goodchild-isingoma-yonah",
    photo: Card8,
    name: "Mr. Goodchild Isingoma Yonah",
    role: "Transport Officer",
    bio: "Isingoma Yonah holds a secondary education certificate and a CM & B driving permit, with certificates in competent driving and road safety…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/Circodu/",
    whatsapp: "https://wa.me/256751178448",
    email: "isingoma.jonah@circodu.org.ug",
  },
  {
    id: "hasifa-namugabo",
    photo: Card7,
    name: "Ms. Hasifa Namugabo",
    role: "Welfare Officer",
    bio: "Hasifa holds a secondary education certificate and a cosmetology certificate from Tina School of Beauty, bringing a wealth of welfare experience…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/namugabo.hasifa/",
    whatsapp: "https://wa.me/256703384157",
    email: "mercyhasifah@gmail.com",
  },
  {
    id: "eunice-kyomuhendo",
    photo: Card6,
    name: "Ms. Eunice Kyomuhendo",
    role: "Cleaner",
    bio: "Eunice holds a primary leaving education certificate and has served as a dedicated cleaner for over six years, contributing to a clean and safe workspace…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/Circodu/",
    whatsapp: "https://wa.me/",
    email: "info@circodu.org.ug",
  },
  {
    id: "bernard-byamukama",
    photo: Card14,
    name: "Mr. Bernard Byamukama",
    role: "Security Officer",
    bio: "Bernard completed secondary education at O-level and holds a National certificate in Automotive Mechanics and Driving, serving as a reliable security officer…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1",
    facebook: "https://www.facebook.com/profile.php?id=100078693347998",
    whatsapp: "https://wa.me/256781893491",
    email: "byamukamaben2020@gmail.com",
  },
  {
    id: "aran-ahereza",
    photo: Card4,
    name: "Mr. Aran Ahereza",
    role: "Security Officer",
    bio: "Aran holds a secondary education certificate at O-level and a National certificate in Automotive Mechanics, serving as a dependable security officer…",
    linkedin:
      "https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu",
    twitter: "https://twitter.com/CIRCODU1/",
    facebook:
      "https://m.facebook.com/people/Allan-Kuz-Ahereza/100088951399209/",
    whatsapp: "https://wa.me/256761383838",
    email: "aherezaallanovic486@gmail.com",
  },
];

/* ─── Single staff card ──────────────────────────────────── */
function StaffCard({ member }) {
  const {
    id,
    photo,
    name,
    role,
    linkedin,
    twitter,
    facebook,
    whatsapp,
    email,
  } = member;
  const profileUrl = `/${id}`;

  return (
    <div className="staff-card">
      {/* Photo */}
      <div className="staff-card__photo-wrap">
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="staff-card__photo-link"
          aria-label={`View profile of ${name}`}
        >
          <img
            src={photo}
            alt={name}
            className="staff-card__photo"
            width="160"
            height="160"
            loading="lazy"
          />
        </a>
      </div>

      {/* Info */}
      <div className="staff-card__body">
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="staff-card__name"
          aria-label={`View profile of ${name}`}
        >
          {name}
        </a>
        <p className="staff-card__role">{role}</p>
        <div className="staff-card__divider" />
        <div className="staff-card__actions">
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="staff-card__read-more"
            aria-label={`Read more about ${name}`}
          >
            Read More
          </a>
        </div>
      </div>

      {/* Social icons
          tabIndex={-1} on IconButton removes it from the tab order since the
          parent <a> already handles focus — fixes the aria-hidden/focusable
          descendants Lighthouse accessibility warning. */}
      <div className="staff-card__socials">
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on LinkedIn`}
        >
          <IconButton size="small" tabIndex={-1}>
            <LinkedInIcon sx={{ fontSize: "20px", color: "darkblue" }} />
          </IconButton>
        </a>
        <a
          href={twitter}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on X / Twitter`}
        >
          <IconButton size="small" tabIndex={-1}>
            <XIcon sx={{ fontSize: "20px", color: "#111" }} />
          </IconButton>
        </a>
        <a
          href={facebook}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on Facebook`}
        >
          <IconButton size="small" tabIndex={-1}>
            <FacebookOutlinedIcon sx={{ fontSize: "20px", color: "#1877f2" }} />
          </IconButton>
        </a>
        <a
          href={whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`WhatsApp ${name}`}
        >
          <IconButton size="small" tabIndex={-1}>
            <WhatsAppIcon sx={{ fontSize: "20px", color: "#25d366" }} />
          </IconButton>
        </a>
        <a
          href={`mailto:${email}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Email ${name}`}
        >
          <IconButton size="small" tabIndex={-1}>
            <EmailIcon sx={{ fontSize: "20px", color: "#e53935" }} />
          </IconButton>
        </a>
      </div>
    </div>
  );
}

/* ─── Page component ─────────────────────────────────────── */
function OurStaff() {
  return (
    <div>
      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img
            src={Card2}
            alt="CIRCODU Staff Team"
            width="1200"
            height="220"
            loading="eager"
            fetchpriority="high"
          />
        </div>
        <div className="ne-hero__overlay">
          <h1 className="ne-hero__title">The Staff Team</h1>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>The Team</Breadcrumb.Item>
            <Breadcrumb.Item active>The Staff Team</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* Grid */}
      <section className="staff-section border-bottom">
        <div className="staff-section__header">
          <div className="row border-top text-center"></div>
        </div>

        <div className="staff-grid">
          {STAFF.map((member) => (
            <StaffCard key={member.id} member={member} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default OurStaff;
